<template>
<div class="group_table_row">
  <div class="group_table_cell">
    <div v-if="group.status == 'alert'" class="elips"></div>
  </div>
  <div class="group_table_cell name" @click="gotoFaucetList">{{group.name}}</div>
  <div v-if="group.status == 'alert'" class="group_table_cell attention">
    <div class="warning"></div>
    Тревога!
  </div>
  <div v-else class="group_table_cell"></div>
  <div class="group_table_cell">{{group.status_text}}</div>
  <div class="group_table_cell">
    <b-btn class="icon cancel" :id="nameDelButtton" @click="del_popover = !del_popover"></b-btn>
  </div>
  <b-popover :show.sync="del_popover" :target="nameDelButtton" title="Удалить эту группу" class="group-del-popover">
    <button type="button" class="btn btn-outline-danger" @click="deleteGroup">Да</button>
    <button type="button" @click="onCloseDelPopover" class="btn btn-outline-info">Нет</button>
  </b-popover>
</div>
</template>

<script>
import config from '@/config.js'
import axios from 'axios'

export default {
  name: 'group-row',
  props: {
    group: Object
  },
  data() { return {
    del_popover: false
  }},
  methods: {
    gotoFaucetList: function (event) {
      this.$router.replace('/faucets-list/' + this.group.id_group)
    },
    onCloseDelPopover() {
      this.del_popover = false
    },
    deleteGroup() {
      this.serial_msg_type = 'hidden'
      this.serial_fail = false
      if (!!localStorage.token) {
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        post_data.set('id_group', this.group.id_group)
        var vue_obj = this
        axios({
            method: 'POST',
            url: config.API_HOST + '/groups/delete_group',
            data: post_data
          })
          .then(function (response) {
            vue_obj.$emit('deleteRow')
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    }
  },
  computed: {
    nameDelButtton: function () {
      return 'delGroup-' + this.group.id_group
    }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/group_row.vue